module.exports = __webpack_public_path__ + "img/tscfunding-white-text-only-powered.9fdbf247.png";